import CheckPasswordStrength from './CheckPasswordStrength';

export default CheckPasswordStrength;
